import React from 'react';
import {
  Body,
  Box,
  Flex,
  Heading,
  HelpCircleIcon,
  Image,
  Link,
} from '@edreamsodigeo/prisma-design-system';
import { useBrand, useTranslation } from '@edreamsodigeo/frontend-core';
import { BreadcrumbPrimeFirstVersioned } from './Breadcrumb';

export function AppHeaderDesktop(props) {
  return (
    <>
      <DefaultHeader>
        <Flex height="100%" justifyContent="space-between" alignItems="center">
          <LogoImage />

          <Flex alignItems="center">
            <HelpCircleIcon color="primary.50" />

            <HelpHeaderItem />
          </Flex>
        </Flex>
      </DefaultHeader>

      <BrandedHeader>
        <Flex
          minHeight="inherit"
          flexDirection="column"
          justifyContent="center"
        >
          <BreadcrumbPrimeFirstVersioned page={props.page} />

          <Box mt="tiny">
            <Heading color="neutral.0" type="2" weight="medium">
              {props.title}
            </Heading>
          </Box>
        </Flex>
      </BrandedHeader>
    </>
  );
}

const DefaultHeader = ({ children }) => (
  <Box
    height="56px"
    backgroundColor="neutral.0"
    pl="2x_big"
    pr="huge"
    py="tiny"
  >
    {children}
  </Box>
);

const BrandedHeader = ({ children }) => (
  <Box minHeight="90px" backgroundColor="primary.50" px="huge">
    {children}
  </Box>
);

const brandDetails = {
  ED: {
    path: 'ED/Logo_eDreams_RGB',
    name: 'edreams',
    height: '40px',
    width: null,
  },
  GO: {
    path: 'GV/GOVoyages_logo_color',
    name: 'govoyages',
    height: '24px',
    width: '123px',
  },
  OP: {
    path: 'OP/Opodo_logo_color',
    name: 'opodo',
    height: '24px',
    width: '92px',
  },
  TL: {
    path: 'TL/Travellink_logo_color',
    name: 'travellink',
    height: '24px',
    width: '112px',
  },
};

const LogoImage = () => {
  const brand = useBrand();
  const path = '/images/onefront/bluestone';
  const imageName = brandDetails[brand].path;
  const logoImageUrl = `${path}/${imageName}.svg`;

  return (
    <Box pt="1x_small">
      <Link
        href="/"
        target={'_self'}
        isUnderlined={false}
        data-testid="home-logo"
      >
        <Image
          src={logoImageUrl}
          alt={`${brandDetails[brand].name} logo image`}
          height={`${brandDetails[brand].height}`}
          width={`${brandDetails[brand].width}`}
          size="auto"
        ></Image>
      </Link>
    </Box>
  );
};

const HelpHeaderItem = () => {
  const { t } = useTranslation();
  return (
    <Box pt="tiny" ml="1x_small">
      <Body type="small">
        <Link
          href={t('header.help.url')}
          target={'_blank'}
          isUnderlined={false}
          data-testid="home-help"
        >
          {t('header.help.text')}
        </Link>
      </Body>
    </Box>
  );
};
